import { FC } from 'react'

interface Props {
  width?: number | string
  height?: number | string
}

const Computer: FC<Props> = ({ width, height, ...props }) => {
  return (
    <svg
      width={width || '17'}
      height={height || '16'}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.4615 12.2404H1.28846C0.946845 12.24 0.619318 12.1042 0.377758 11.8626C0.136199 11.6211 0.000341105 11.2935 0 10.9519V1.28846C0.000341105 0.946845 0.136199 0.619318 0.377758 0.377759C0.619318 0.136199 0.946845 0.000341105 1.28846 0H15.4615C15.8032 0.000341105 16.1307 0.136199 16.3722 0.377759C16.6138 0.619318 16.7497 0.946845 16.75 1.28846V10.9519C16.7497 11.2935 16.6138 11.6211 16.3722 11.8626C16.1307 12.1042 15.8032 12.24 15.4615 12.2404ZM1.28846 1.28846V10.9519H15.4625L15.4615 1.28846H1.28846Z"
        fill="currentColor"
      />
      <path
        d="M12.2405 15.4616H4.50971C4.33885 15.4616 4.17499 15.3937 4.05417 15.2729C3.93335 15.1521 3.86548 14.9882 3.86548 14.8173C3.86548 14.6465 3.93335 14.4826 4.05417 14.3618C4.17499 14.241 4.33885 14.1731 4.50971 14.1731H12.2405C12.4113 14.1731 12.5752 14.241 12.696 14.3618C12.8168 14.4826 12.8847 14.6465 12.8847 14.8173C12.8847 14.9882 12.8168 15.1521 12.696 15.2729C12.5752 15.3937 12.4113 15.4616 12.2405 15.4616Z"
        fill="currentColor"
      />
      <path
        d="M10.952 15.4615H5.79814C5.69285 15.4615 5.58917 15.4357 5.49616 15.3863C5.40316 15.337 5.32366 15.2656 5.26463 15.1784C5.2056 15.0912 5.16882 14.9909 5.15753 14.8862C5.14623 14.7815 5.16076 14.6757 5.19983 14.5779L6.48829 11.3568C6.53623 11.2373 6.61883 11.1349 6.72545 11.0627C6.83208 10.9906 6.95786 10.952 7.0866 10.9519H9.66352C9.79226 10.952 9.91804 10.9906 10.0247 11.0627C10.1313 11.1349 10.2139 11.2373 10.2618 11.3568L11.5503 14.5779C11.5894 14.6757 11.6039 14.7815 11.5926 14.8862C11.5813 14.9909 11.5445 15.0912 11.4855 15.1784C11.4265 15.2656 11.347 15.337 11.254 15.3863C11.161 15.4357 11.0573 15.4615 10.952 15.4615ZM6.7497 14.1731H10.0005L9.22725 12.2404H7.52294L6.7497 14.1731Z"
        fill="currentColor"
      />
      <path
        d="M16.1058 9.66346H0.644231C0.47337 9.66346 0.309507 9.59559 0.188691 9.47477C0.0678741 9.35395 0 9.19009 0 9.01923C0 8.84837 0.0678741 8.68451 0.188691 8.56369C0.309507 8.44287 0.47337 8.375 0.644231 8.375H16.1058C16.2766 8.375 16.4405 8.44287 16.5613 8.56369C16.6821 8.68451 16.75 8.84837 16.75 9.01923C16.75 9.19009 16.6821 9.35395 16.5613 9.47477C16.4405 9.59559 16.2766 9.66346 16.1058 9.66346Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Computer
